import React from "react";
import styled from "styled-components/macro";

type ColorTypes = "green" | "red" | "blue" | "gray";

const getCountColor = (color: ColorTypes) => {
  switch (color) {
    case "green":
      return "var(--background-green)";
    case "red":
      return "var(--background-error-color)";
    case "blue":
      return "var(--light-blue)";
    case "gray":
      return "var(--border-gray-light)";
  }
};

const StyledCount = styled.div<{
  color: ColorTypes;
  size?: "small" | "medium";
}>`
  line-height: 1em;
  height: ${({ size }) => (size === "small" ? "1.5rem" : "2rem")};
  width: ${({ size }) => (size === "small" ? "1.5rem" : "2rem")};
  border: 1px solid var(--border-gray);
  font-size: ${({ size }) =>
    size === "small" ? "var(--font-size-xxsmall)" : "var(--font-size-small)"};
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: var(--font-weight-bold);
  background: ${(props) => getCountColor(props.color)};
  border-radius: 50%;
  color: var(--dark-gray);
  margin-left: 0.5rem;
`;

interface props {
  color: ColorTypes;
  count: number;
  className?: string;
  size?: "small" | "medium";
}

export const Count: React.FC<props> = ({ count, color, className, size }) => (
  <StyledCount color={color} className={className} size={size}>
    {count}
  </StyledCount>
);
